import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ApiService } from '../../api/api.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-candidateform',
  templateUrl: './candidateform.component.html',
  styleUrls: ['./candidateform.component.css']
})
export class CandidateformComponent implements OnInit {

  criForm: any;
  submitted: any;

  candidateLoginForm: any;

  NTEF = [
    {
      id: 1,
      name: 'Exam Incomplete',
      ntefSub: ['Internet Failure during Exam', 'Power Failure During Exam', 'Question and Images not loaded properly', 'Submission Error'],

    },
    {
      id: 2,
      name: 'Student Absent',
      ntefSub: ['Hall Ticket Issues', 'Came Late'],
    },
    {
      id: 3,
      name: 'Student Present - Unable to attend the Exam',
      ntefSub: ['Total Power Failure', 'Total Internet Breakdown', 'Attendance app did not work', 'SEB Issue', 'Computer Systems Failure'],
    },
    {
      id: 4,
      name: 'Others'
    }
  ];

  ntefsub_bool: boolean = false;
  ntefSub: any = {};
  ntefdesc_bool: boolean = false;
  ntefmain_bool: boolean = false;

  public mail_single: any;
  public state_single: any;
  public district_single: any;
  public iticode_single: any;
  public trade_single: any;
  public regno_single: any;
  public criregno_single: any;
  public invigilator_name: any;
  public invigilator_role: any;
  public cri_username: any;
  public cri_examdate: any;
  public cri_attendance: any;
  public cri_cenername: any;
  public cri_invigemail: any;
  public cri_examstatus: any;
  public cri_shift: any;
  public cri_email: any;
  public cri_genrateid: any;
  public criform_bool: boolean = true;
  public criform_status_bool: boolean = false;

  public test_cri: any;
  public test_cri_invigi: any;
  public show_msg_bool: boolean = false;
  public submit_btn_bool: boolean = false;

  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router) { }

  ngOnInit(): void {

    this.candidateLoginForm = this.formBuilder.group({
      regno: [window.localStorage.getItem('candidate_regno')],
      userid: [window.localStorage.getItem('candidate_userid')],
    });

    this.api.checkLcriregno(this.candidateLoginForm.value).subscribe((result: any) => {


      if (window.localStorage.getItem('candidate_regno') == result.regno) {
        this.show_msg_bool = true;
        this.submit_btn_bool = true;
      }
      else {
        this.show_msg_bool = false;
        this.submit_btn_bool = false;
      }
    });

    this.api.candidateLoginForm(this.candidateLoginForm.value)
      .subscribe((result: any) => {

        var result_var = result['message'];
        this.test_cri = result;
        console.log(result)
        // window.localStorage.setItem('email', result.email)
        // window.localStorage.setItem('mobile', result.mobile)

        if (result_var == 'No data Found') {
          alert("Please Login with valid Credentials");
          return;
        }
        {



          this.iticode_single = result.iticode;

          var iti_args = {
            iticode: this.iticode_single
          };


          this.api
            .candidate_iti(iti_args)
            .subscribe((result: any) => {
              console.log("candidate iti : " + JSON.stringify(result))
              this.test_cri_invigi = result;
              this.invigilator_name = result;
              // this.cri_status_admin = result;
            });


          this.api.candidate_map_invig(iti_args)
            .subscribe((result: any) => {
              console.log("candidate iti : " + JSON.stringify(result))
              // this.test_cri_invigi = result;
              this.state_single = result[0]['State'];
              this.district_single = result[0]['district'];
              // this.cri_status_admin = result;
            });


          var cri_iticode = {
            iticode: result.iticode
          };


          console.log(JSON.stringify(result));

          this.invigilator_role = result.role;
          //alert(this.invigilator_role)
          var cri = result;

          this.criForm.state = result.State;
          this.mail_single = result.userid;
          this.trade_single = result.trade;
          this.regno_single = result.regno;
          this.cri_username = result.username;
          this.cri_examdate = result.examdate;
          this.cri_shift = result.Shift;
          this.cri_examstatus = result.status;
          this.cri_cenername = result.centercode;

          if ('submitted' == this.cri_examstatus) {
            this.cri_attendance = 'Present';
          }
          else {
            this.cri_attendance = 'Abscent';
          }

          // this.state_single = result.State;
          // this.district_single = result.district;


        }

      });


    this.criForm = this.formBuilder.group({
      // genrateid: ['cri'],
      email: ['', Validators.required],
      state: ['', Validators.required],
      district: ['', Validators.required],
      iticode: ['', Validators.required],
      trade: ['', Validators.required],
      regno: ['', Validators.required],
      username: ['', Validators.required],
      date: ['', Validators.required],
      shift: ['', Validators.required],
      attendance: ['', Validators.required],
      center: ['', Validators.required],
      status: ['', Validators.required],
      invigilatorname: ['', Validators.required],
      invigEmail: [''],
      ntef: ['', Validators.required],
      issuedetail: [''],
      description: ['']

    });

  }

  get cri() {
    return this.criForm.controls;
  }

  rollnochange(data: any) {
    //console.log(data.target.value);
    var myargs = {
      rollNo: data.target.value
    };

    this.api.enterEriRollno(myargs).subscribe((result: any) => {
      console.log("Roll no: " + JSON.stringify(result));

      console.log(result[0]['username']);

      this.cri_username = result[0]['username'];
      this.cri_examdate = result[0]['examdate'];
      this.cri_shift = result[0]['Shift'];
      if ('submitted' == result[0]['status']) {
        this.cri_attendance = 'Present';
      }
      else {
        this.cri_attendance = 'Abscent';
      }
      //this.cri_attendance = result[0]['attendance'];
      this.cri_cenername = result[0]['centercode'];
      this.cri_examstatus = result[0]['status'];
      //this.cri_email = result[0]['email'];

      this.ntefmain_bool = true;

      //[{"username":"RAMESH KUMAR","examdate":"29-01-2021","attendance":"Present/9805903461/Q/2021-01-29 10:41:42","cenername":"GR02000207-Govt. ITI Rajgarh, Rajgarh, SIRMAUR, HIMACHAL PRADESH, -173101","examstatus":"submitted"}]
    });
  }

  ntefonChange(event: any) {
    var ntef_val = event.target.value;
    this.ntefSub = this.NTEF.filter(x => x.name == ntef_val)[0].ntefSub;
    this.ntefsub_bool = true;

    if (event.target.value == 'Others') {

      this.ntefsub_bool = false;
      this.ntefdesc_bool = true;
      this.criForm.get('issuedetail').clearValidators();
      this.criForm.get('issuedetail').value = '';
      this.criForm.get('issuedetail').updateValueAndValidity();

      this.criForm.get('description').setValidators([Validators.required]);

    }
    else {

      this.ntefdesc_bool = false;
      this.criForm.get('description').clearValidators();
      this.criForm.get('description').value = '';
      this.criForm.get('description').updateValueAndValidity();

      this.criForm.get('issuedetail').setValidators([Validators.required]);
    }
  }

  tradeChange(data: any) {
    this.ntefmain_bool = true;
    //console.log(data.target.value);
    var myargs = {
      iticode: this.iticode_single,
      name: data.target.value
    };

    alert(data.target.value + '' + this.iticode_single)

    this.api.enterEriInvgName(myargs).subscribe((result: any) => {
      console.log("enterEriInvgName " + JSON.stringify(result))
      this.cri_invigemail = result[0]['email'];
    });
    // this.api.enterEriTrade(myargs).subscribe((result: any) => {
    //   this.criregno_single = result;

    //   this.criForm.get('username').reset();
    //   this.criForm.get('date').reset();
    //   this.criForm.get('shift').reset();
    //   this.criForm.get('attendance').reset();
    //   this.criForm.get('status').reset();
    //   this.criForm.get('center').reset();
    //   this.criForm.get('ntef').reset();
    //   this.criForm.get('issuedetail').reset();
    //   this.criForm.get('description').reset();

    // });
  }

  oncriSubmit() {
    this.submitted = true;

    if (this.criForm.invalid) {
      return;
    }

    console.log(JSON.stringify(this.criForm.value));


    var cri_regno = {
      regno: this.criForm.value.regno
    };

    this.api
      .insertCriForm(this.criForm.value)
      .subscribe((result: any) => {
        alert("Success");
        this.cri_genrateid = result.refid;
        this.criform_bool = false;
        this.criform_status_bool = true;
      });

    // this.api.checkLeriregno(cri_regno).subscribe((result: any) => {
    //   // console.log(result);

    //   var check_regno = result.regno;
    //   if (this.criForm.value.regno == check_regno) {
    //     alert("Grievance already raised for this Registeration Number: " + check_regno);
    //     return;
    //   }
    //   else {
    //     // stop here if form is invalid
    //     if (this.criForm.invalid) {
    //       return;
    //     }

    //     //alert("cri Form created SUCESS");
    //     console.log(this.criForm.value);
    //     this.api
    //       .insertEriForm(this.criForm.value)
    //       .subscribe((result: any) => {
    //         this.cri_genrateid = result.refid;

    //         this.criform_bool = false;
    //         this.criform_status_bool = true;

    //         // this.form3 = false;
    //         // this.formDetail3 = true;   open TICKET ID FORM
    //         // this.bool_cri_result = true;
    //         //alert("your id no: " + result.refid);
    //       });
    //   }

    // });


  }

  back_fn() {
    this.criform_bool = true;
    this.criform_status_bool = false;
  }

  omit_spl(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  // check_regnumber(event: any) {
  //   var cri_regno = {
  //     regno: event.target.value
  //   };


  //   this.api.checkLcriregno(cri_regno).subscribe((result: any) => {
  //     // console.log(result);

  //     var check_regno = result.regno;
  //     if (this.criForm.value.regno == check_regno) {
  //       alert("Grievance already raised for this Registeration Number: " + check_regno);
  //       this.criForm.get('regno').reset();
  //       this.criForm.get('username').reset();
  //       this.criForm.get('date').reset();
  //       this.criForm.get('shift').reset();
  //       this.criForm.get('attendance').reset();
  //       this.criForm.get('status').reset();
  //       this.criForm.get('center').reset();
  //       this.criForm.get('ntef').reset();
  //       this.criForm.get('issuedetail').reset();
  //       this.criForm.get('description').reset();
  //       return;
  //     }


  //   });




  // }

}
